<script>
  import { gql } from "@apollo/client/core";
  import { _ as t } from "svelte-i18n";

  import { client } from "../apollo";

  import { Button } from "t2c-components";
  import LangSwitch from "components/LangSwitch.svelte";
  import Input from "components/Input.svelte";
  import Errors from "components/Errors.svelte";

  export let token;
  export let config;

  const CLIENT_CHANGE_PASSWORD_MUTATION = gql`
    mutation (
      $token: String!
      $password: String!
      $passwordConfirmation: String!
    ) {
      changeClientPassword(
        token: $token
        password: $password
        passwordConfirmation: $passwordConfirmation
      ) {
        email
      }
    }
  `;

  let password = "";
  let passwordConfirmation = "";
  let errorMessages = [];

  const setErrorMessage = (message) => {
    errorMessages = [{ message: message }];
    // clear password input
    inFlight = false;
    password = "";
    passwordConfirmation = "";
  };

  const resetErrors = () => {
    errorMessages = [];
  };

  let inFlight = false;
  $: filledValid =
    password === passwordConfirmation &&
    password !== "" &&
    password.length >= 8;

  const redirect = (path) => {
    window.location.href = path;
  };

  const reset = async () => {
    const result = await client.mutate({
      mutation: CLIENT_CHANGE_PASSWORD_MUTATION,
      variables: {
        token,
        password,
        passwordConfirmation,
      },
    });

    return result;
  };

  const handleRecover = (e) => {
    e.preventDefault();
    inFlight = true;
    reset()
      .then((r) => {
        inFlight = false;
        redirect("/");
      })
      .catch((err) => {
        const { graphQLErrors, networkError } = err;
        const messages = graphQLErrors.map(({ message }) => message);
        let errorMessage = messages.join(" ");
        setErrorMessage(errorMessage);
      });
  };

  const handleBackToLogin = () => {
    redirect("/login");
  };
</script>

<div class="wrapper">
  <div class="modal">
    {#if config.logoHash}
      <div class="logo">
        <img
          src={`/download-file/logo/${config.id}?hash=${config.logoHash}`}
          alt="logo"
        />
      </div>
    {:else}
      <h1 class="title">{config.lawyerName}</h1>
    {/if}
    <h1 class="title">{$t("welcome.resetPassword")}</h1>
    <form on:submit|preventDefault={handleRecover}>
      <p>{$t("userSettings.minLengthPassword")}</p>
      <Input
        label={$t("userSettings.newPassword")}
        on:change={resetErrors}
        on:focus={resetErrors}
        bind:value={password}
        type="password"
        disabled={inFlight}
      />
      <p class="suggestion">
        {#if password.length > 0 && password.length < 8}
          {$t("userSettings.minLengthPassword")}
        {/if}
      </p>
      <Input
        label={$t("userSettings.newPasswordConfirm")}
        on:change={resetErrors}
        on:focus={resetErrors}
        bind:value={passwordConfirmation}
        type="password"
        disabled={inFlight}
      />
      <p class="suggestion">
        {#if passwordConfirmation.length > 0 && password !== passwordConfirmation}
          {$t("welcome.notMatch")}
        {/if}
      </p>
      {#if errorMessages.length > 0}
        <Errors {errorMessages} />
        <div class="nav-link">
          <Button on:click={handleBackToLogin}>Login</Button>
        </div>
      {/if}
      {#if errorMessages.length === 0}
        <div class="action">
          <Button
            style="primary"
            type="submit"
            disabled={inFlight || !filledValid}
          >
            {$t("welcome.resetPassword")}
          </Button>
        </div>
      {/if}
      <LangSwitch />
    </form>
  </div>
</div>

<style>
  .wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100vh;
    background-color: #eeeeee;
  }

  .wrapper::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: var(--client-background-image);
    background-size: cover;
    filter: grayscale(100%);
  }

  .modal {
    z-index: 1;
    margin-top: 48px;
    margin: 0 auto;
    max-width: 900px;
    padding: 24px;
    border: 2px solid black;
    background-color: rgba(255, 255, 255, 0.95);
  }

  .action {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
  }

  h1 {
    font-size: 26px;
    font-weight: 400;
    text-transform: uppercase;
    margin-top: 24px;
  }

  p {
    max-width: 30em;
  }

  .logo {
    display: flex;
    justify-content: center;
  }

  .logo img {
    height: 150px;
  }

  .title {
    line-height: 2.5rem;
  }

  .suggestion {
    font-size: 12px;
    font-weight: 300;
    color: var(--blue-color);
    height: 0;
    margin: 0;
    padding-bottom: 0.5rem;
  }

  .nav-link {
    display: flex;
    justify-content: center;
  }
</style>
